import IProduct from 'models/Product';

import { ReduxStore } from 'store/types';

function getAllList(state: ReduxStore): IProduct[] {
  return state.product.getAll.list;
}

export default getAllList;
